import ProductItemView from "../../products-list/view/product-item.js";

import {
  formatNumber
} from "../../../utils/format-number.js";

export default class CartProductItem extends ProductItemView {
  constructor(element) {
    super(element);

    this._productFormElement = null;
    this._propertiesWrapperElement = null;
    this._totalPriceElement = null;
    this._totalPriceValueElement = null;
    this._summaryElement = null;
    this._quantityElement = null;
    this._summaryQuantityElement = null;
    this._removeButtonElement = null;

    this._sessionElementId = null;
    this._price = null;

    this._removeButtonClickHandler = this._removeButtonClickHandler.bind(this);
  }

  getsessionElementId() {
    if (!this._sessionElementId) {
      this._sessionElementId = this._element.dataset.sessionElementId;
    }

    return this._sessionElementId;
  }

  getPrice() {
    if (!this._price) {
      this._price = parseFloat(this._element.dataset.price);
    }

    return this._price;
  }

  getProductFormElement() {
    if (!this._productFormElement) {
      this._productFormElement = this._element.querySelector(`.product-item-form`);
    }

    return this._productFormElement;
  }

  getPropertiesWrapperElement() {
    if (!this._propertiesWrapperElement) {
      this._propertiesWrapperElement = this._element.querySelector(`.product-item-properties-wrapper`);
    }

    return this._propertiesWrapperElement;
  }

  getTotalPriceElement() {
    if (!this._totalPriceElement) {
      this._totalPriceElement = this._element.querySelector(`.product-item__price`);
    }

    return this._totalPriceElement;
  }

  getTotalPriceValueElement() {
    if (!this._totalPriceValueElement) {
      this._totalPriceValueElement = this._element.querySelector(`.product-item__price-value`);
    }

    return this._totalPriceValueElement;
  }

  getQuantity() {
    return (this.getSummaryQuantityElement()) ?
      +this.getSummaryQuantityElement().textContent :
      null;
  }

  getSummaryElement() {
    if (!this._summaryElement) {
      this._summaryElement = this._element.querySelector(`.product-item-summary`);
    }

    return this._summaryElement;
  }

  getQuantityElement() {
    if (!this._quantityElement) {
      this._quantityElement = this._element.querySelector(`.product-quantity`);
    }

    return this._quantityElement;
  }

  getSummaryQuantityElement() {
    if (!this._summaryQuantityElement) {
      this._summaryQuantityElement = this._element.querySelector(`.product-item-summary__quantity`);
    }

    return this._summaryQuantityElement;
  }

  getRemoveButtonElement() {
    if (!this._removeButtonElement) {
      this._removeButtonElement = this._element.querySelector(`.button_cart-remove`);
    }

    return this._removeButtonElement;
  }

  getTotalPrice() {
    return (this.getTotalPriceValueElement()) ?
      parseFloat(this.getTotalPriceValueElement().textContent.replace(/\s/ig, ``).replace(/,/ig, `.`)) :
      null;
  }

  setTotalPriceValue(price) {
    if (this.getTotalPriceValueElement()) {
      this.getTotalPriceValueElement().textContent = formatNumber(price, 2, `,`, `\u00A0`);
    }
  }

  setRemoving() {
    this._element.classList.add(`product-item_cart_removing`);
  }

  unsetRemoving() {
    this._element.classList.remove(`product-item_cart_removing`);
  }

  setRemoveButtonClickHandler(callback) {
    this._callback.removeButtonClick = callback;
    this.getRemoveButtonElement().addEventListener(`click`, this._removeButtonClickHandler);
  }

  _removeButtonClickHandler(evt) {
    this._callback.removeButtonClick(evt);
  }
}
